export default {
   get profileData() {
      try {
         if (
            typeof window !== 'undefined' &&
            window.localStorage &&
            window.localStorage.getItem('userInfo')
         ) {
            let userInfo = window.localStorage.getItem('userInfo');
            userInfo = JSON.parse(userInfo);
            return userInfo;
         }
         return false;
      } catch (error) {
         // eslint-disable-next-line
         console.warn(error);
         return false;
      }
   },

   set profileData(param) {
      try {
         // merging exisiting data with new user's data
         const data = Object.assign({}, this.profileData, param);
         if (typeof window !== 'undefined' && window.localStorage) {
            window.localStorage.setItem('userInfo', JSON.stringify(data));
         }
      } catch (error) {
         // eslint-disable-next-line
         console.warn(error);
      }
   },
};
